(() => {
  const button = document.querySelector('.ss-sparkles-toggle');
  const layer = document.querySelector('.ss-falling-sparkles');
  if (!button || !layer) return;
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let enabled = true;
  try { enabled = localStorage.getItem('ss-sparkles') !== 'off'; } catch (_) {}
  const render = () => {
    const active = enabled && !motion.matches;
    layer.hidden = !active;
    button.hidden = motion.matches;
    button.setAttribute('aria-pressed', String(active));
    button.setAttribute('aria-label', active ? 'Turn falling sparkles off' : 'Turn falling sparkles on');
    button.querySelector('span').textContent = active ? 'Sparkles on' : 'Sparkles off';
  };
  button.addEventListener('click', () => {
    enabled = !enabled;
    try { localStorage.setItem('ss-sparkles', enabled ? 'on' : 'off'); } catch (_) {}
    render();
  });
  motion.addEventListener('change', render);
  render();
})();